import { Link, useParams } from 'react-router-dom';
import { version_contents } from './contents';

export const ErpDocumentation = () => {
  const { docVersion } = useParams();

  const currentContent =
    version_contents[docVersion] || version_contents.default;

  return (
    <div className="documentation-wrapper">
      <hr />
      <ul>
        <li>
          <Link to="/integracao-erp">ERP Documentation: latest</Link>
        </li>
        <li>
          <Link to="/integracao-erp/v0">ERP Documentation v0</Link>
        </li>
      </ul>
      {currentContent}
    </div>
  );
};
